// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

/////////////////////////////////////////
// SCAN PROFILE SETTINGS SCHEMA
/////////////////////////////////////////

export const ScanProfileSettingsSchema = z.object({
})

export type ScanProfileSettings = z.infer<typeof ScanProfileSettingsSchema>

export default ScanProfileSettingsSchema;
